<a class="skip-link" href="#main-content" (click)="skipToMain($event)">
  {{ 'COMMON.ACTION.SKIP_TO_MAIN_CONTENT' | translate }}
</a>

@if (myself$ | async) {
  <div class="layout-wrapper">
    <!------------------------->
    <!-- DESKTOP LEFT COLUMN -->
    <!------------------------->
    @if (deviceInfo.deviceTypeDetected === 'DESKTOP') {
      <div class="column column-left">
        <div class="logo-container">
          <app-company-logo (logoClicked)="logoClicked()"></app-company-logo>
        </div>
        @if (hasApplications$ | async) {
          <app-application-selector
            class="application-selector-container"
            [myProcesses$]="myProcesses$"
            [myProcess]="myProcess"
            [myWorkPermits]="myWorkPermits$ | async"
            [selectedWorkPermitId]="selectedWorkPermitId"
            [addingNewProcess]="addingNewProcess"
            [myself$]="myself$"
            (applicationChanged)="applicationChanged($event)">
          </app-application-selector>
        }
        @if (!isForeigner || (isForeigner && (hasApplications$ | async) === false)) {
          <div class="margin-setter"></div>
        }
        <app-sidebar-menu
          class="menu-items-container"
          [sideMenuItems]="sideMenuItems"
          [isForeigner]="isForeigner"
          [myProcess]="myProcess"
          [selectedWorkPermitId]="selectedWorkPermitId"
          [addingNewProcess]="addingNewProcess">
        </app-sidebar-menu>
        @if (allowedToParticipateInPartnerProgram) {
          <div (click)="openMyPartnerAccountDrawer()" class="partner-account-promo-container">
            <span class="gift-icon" nz-icon nzType="gift" nzTheme="outline"></span>
            <span class="promo-text" [translate]="'PARTNER_ACCOUNT.GIVE_AND_EARN'"></span>
          </div>
        }
      </div>
    } @else {
      <nz-drawer
        [nzClosable]="false"
        [nzVisible]="showSidebar"
        [nzPlacement]="'left'"
        [nzWidth]="sidebarWidth"
        [nzBodyStyle]="{
          padding: '0',
        }"
        (nzVisibleChange)="onDrawerVisibilityChange($event)"
        (nzOnClose)="toggleSidebar()">
        <ng-container *nzDrawerContent>
          <div
            class="column column-left"
            appSwipe
            tabindex="-1"
            #drawerFocus
            role="dialog"
            (swipeLeft)="toggleSidebar()"
            [attr.aria-modal]="true"
            [attr.aria-labelledby]="'sidebar-title'">
            <h2 id="sidebar-title" class="sr-only">
              {{ 'COMMON.LAYOUT.SIDEBAR' | translate }}
            </h2>
            <button
              id="close-button-container_left"
              mat-icon-button
              type="button"
              class="mobile-menu-button mobile-menu-button-light"
              [attr.aria-label]="'COMMON.ACTION.CLOSE' | translate"
              (click)="toggleSidebar()">
              <mat-icon>menu</mat-icon>
            </button>
            <div class="utils-buttons-wrapper">
              <app-utils-buttons [theme]="'LIGHT'"></app-utils-buttons>
            </div>
            @if (hasApplications$ | async) {
              <app-application-selector
                class="application-selector-container"
                [myProcesses$]="myProcesses$"
                [myProcess]="myProcess"
                [myWorkPermits]="myWorkPermits$ | async"
                [selectedWorkPermitId]="selectedWorkPermitId"
                [addingNewProcess]="addingNewProcess"
                [myself$]="myself$"
                (applicationChanged)="applicationChanged($event)">
              </app-application-selector>
            }
            <app-sidebar-menu
              class="menu-items-container"
              [sideMenuItems]="sideMenuItems"
              [isForeigner]="isForeigner"
              [myProcess]="myProcess"
              [selectedWorkPermitId]="selectedWorkPermitId"
              [addingNewProcess]="addingNewProcess">
            </app-sidebar-menu>
            @if (allowedToParticipateInPartnerProgram) {
              <div (click)="openMyPartnerAccountDrawer()" class="partner-account-promo-container">
                <span class="gift-icon" nz-icon nzType="gift" nzTheme="outline"></span>
                <span class="promo-text" [translate]="'PARTNER_ACCOUNT.GIVE_AND_EARN'"></span>
              </div>
            }
          </div>
        </ng-container>
      </nz-drawer>
    }
    <!------------------------>
    <!-- MOBILE LEFT COLUMN -->
    <!------------------------>
    <!------------------>
    <!-- RIGHT COLUMN -->
    <!------------------>
    <div class="column column-right">
      @if ((maintenanceInfo$ | async)?.maintenanceUpcoming) {
        <div class="shout-container">
          @if ((maintenanceInfo$ | async)?.message; as message) {
            <div class="shout-message" [innerHTML]="message[currentLang]"></div>
          }
        </div>
      }
      <div class="topbar" [class.has-progress-bar]="showProgressBar" [class.has-shadow]="showTopbarShadow">
        <div class="row">
          @if (deviceInfo.deviceTypeDetected !== 'DESKTOP') {
            <button
              id="close-button-container_right"
              mat-icon-button
              type="button"
              class="mobile-menu-button mobile-menu-button-primary open-sidebar-button"
              [attr.aria-label]="'COMMON.LAYOUT.TOP_BAR_MENU' | translate"
              (click)="toggleSidebar()">
              <mat-icon>menu</mat-icon>
            </button>
          }
          @if (deviceInfo.deviceTypeDetected === 'DESKTOP') {
            <div class="utils-buttons-wrapper">
              <app-utils-buttons></app-utils-buttons>
            </div>
          }
          @if (deviceInfo.deviceTypeDetected === 'DESKTOP' && showProgressBar) {
            <div class="percentages-container">
              <div
                matTooltip="{{ 'COMMON.LAYOUT.COMPLETION_PERCENTAGE' | translate }}"
                matTooltipClass="personalDataFormTooltip">
                <span class="progress-percent-text">{{ progressPercentage }} %</span>
              </div>
            </div>
          }
          <div class="menu-buttons">
            <!-- Admins Settings - Only for administrators buttons -->
            @if (isAdministrator) {
              <button
                mat-button
                [routerLink]="['/administration/system-settings']"
                [attr.aria-label]="'COMMON.LAYOUT.SYSTEM_SETTINGS' | translate">
                <mat-icon fontSet="material-icons-outlined">construction</mat-icon>
              </button>
            }
            <!-- Admins buttons END -->
            <!-- Guide -->
            @if (deviceInfo.deviceTypeDetected === 'DESKTOP' && isForeigner) {
              <button
                mat-button
                disableRipple
                [matMenuTriggerFor]="helpmenu"
                class="open-help-button"
                aria-haspopup="menu"
                aria-controls="helpmenu"
                [attr.aria-label]="'COMMON.LAYOUT.GUIDE' | translate">
                <mat-icon fontSet="material-icons-outlined">question_mark</mat-icon>
              </button>
            }
            <mat-menu #helpmenu="matMenu" id="helpmenu">
              @if (isForeigner) {
                <button mat-menu-item (click)="openGuide(GUIDE_NAME.FIRST_TIME)">
                  <mat-icon class="regular-text-color" fontSet="material-icons-outlined">live_help</mat-icon>
                  {{ 'GUIDE.RESTART_GLOBAL_GUIDE' | translate }}
                </button>
              }
            </mat-menu>
            <!-- Notifications -->
            <button
              mat-button
              (click)="toggleNotificationsWindow()"
              class="open-notifications-button"
              [class.has-unread-notifications]="unreadNotificationsCount > 0"
              [class.received-notification]="newNotificationReceived"
              [attr.aria-label]="'COMMON.LAYOUT.NOTIFICATIONS' | translate"
              [attr.aria-expanded]="showNotifications"
              [attr.aria-haspopup]="'dialog'"
              [attr.aria-controls]="'notifications-panel'">
              <mat-icon
                class="open-notifications-icon"
                [matBadgeHidden]="unreadNotificationsCount === 0"
                matBadgePosition="before"
                matBadgeSize="medium"
                [matBadgeColor]="'warn'"
                fontSet="material-icons-outlined"
                [matBadge]="unreadNotificationsCount"
                >notifications
              </mat-icon>
            </button>
            <!-- Top Bar Menu -->
            <button
              mat-button
              (click)="toggleTopbarMenu()"
              class="open-topbar-menu-button"
              [attr.aria-label]="'COMMON.LAYOUT.TOP_BAR_MENU' | translate"
              [attr.aria-expanded]="showTopbarMenu"
              [attr.aria-haspopup]="'menu'"
              [attr.aria-controls]="'topbar-menu'">
              @if (deviceInfo.deviceTypeDetected === 'DESKTOP') {
                <mat-icon fontSet="material-icons-outlined" class="open-topbar-menu-icon">person </mat-icon>
              }
              @if (deviceInfo.deviceTypeDetected !== 'DESKTOP') {
                <mat-icon fontSet="material-icons-outlined" class="open-topbar-menu-icon">settings </mat-icon>
              }
            </button>
          </div>
        </div>
        @if (deviceInfo.deviceTypeDetected === 'DESKTOP' && showProgressBar) {
          <div
            class="row row-progress-bar"
            role="progressbar"
            [attr.aria-label]="'COMMON.LAYOUT.PROGRESSBAR' | translate"
            [attr.aria-valuemin]="0"
            [attr.aria-valuemax]="100"
            [attr.aria-valuenow]="progressPercentage"
            [attr.aria-valuetext]="'COMMON.LAYOUT.SURVEY_COMPLETION' | translate: { percent: progressPercentage }">
            <mat-progress-bar
              mode="determinate"
              [value]="progressPercentage"
              [attr.aria-hidden]="true"></mat-progress-bar>
          </div>
        }
      </div>
      @if (infoBarState.show) {
        <div class="top-info-bar" [ngClass]="infoBarState.type" (click)="infoBarClicked()">
          @if (infoBarState.type === 'logout-warning') {
            <span
              class="text-content"
              [innerHTML]="'TOP_BAR.LOGOUT_WARNING' | translate: { timeLeft: infoBarState.timeLeft }">
            </span>
          } @else {
            @if (infoBarState.type === 'info' && deviceInfo.deviceTypeDetected !== 'PHONE') {
              <mat-icon class="icon-info" svgIcon="info-outline"></mat-icon>
            }
            <div
              class="text-content"
              [innerHTML]="infoBarState.message | translate: infoBarState.translateParams"></div>
            <!-- <mat-icon *ngIf="infoBarState.action === 'PAGE_REFRESH'"
            (click)="infoBarClicked()"
            class="icon-refresh"
            svgIcon="refresh">
          </mat-icon> -->
          }
        </div>
      }
      @if (showNotifications) {
        <app-notifications id="notifications-panel" role="dialog" (closeNotifications)="showNotifications = false">
        </app-notifications>
      }
      @if (showTopbarMenu) {
        <app-topbar-menu id="topbar-menu" role="menu" (closeTopbarMenu)="showTopbarMenu = false"> </app-topbar-menu>
      }
      <main
        id="main-content"
        class="content"
        #contentWrapper
        [class.with-bottom-bar]="showBottomFixedBar"
        [class.with-progress-indicator]="showProgressBar"
        [class.with-info-bar]="infoBarState.show"
        [class.no-left-margin]="isInSummary">
        @if (deviceInfo.deviceTypeDetected !== 'DESKTOP' && showProgressBar) {
          <div
            class="mobile-percentages-container"
            role="progressbar"
            [attr.aria-label]="'COMMON.LAYOUT.PROGRESSBAR' | translate"
            [attr.aria-valuemin]="0"
            [attr.aria-valuemax]="100"
            [attr.aria-valuenow]="progressPercentage"
            [attr.aria-valuetext]="'COMMON.LAYOUT.SURVEY_COMPLETION' | translate: { percent: progressPercentage }">
            <mat-progress-bar
              mode="determinate"
              [value]="progressPercentage"
              [attr.aria-hidden]="true"></mat-progress-bar>
            <span class="progress-percent-text" [attr.aria-hidden]="true">{{ progressPercentage }} %</span>
          </div>
        }
        <router-outlet></router-outlet>
        <!-- Foreinger uses app-chat -->
        @if (isForeigner || isEmployer) {
          @if (deviceInfo.deviceTypeDetected === 'DESKTOP') {
            <app-chat-desktop></app-chat-desktop>
          }
          @if (deviceInfo.deviceTypeDetected !== 'DESKTOP') {
            <app-chat-mobile-button></app-chat-mobile-button>
          }
        }
        <!-- Employees/admins use support-chat/private-convos -->
        @if (userShouldSeeChatsList) {
          @if (deviceInfo.deviceTypeDetected === 'DESKTOP') {
            <app-chats-wrapper-desktop></app-chats-wrapper-desktop>
          }
          @if (deviceInfo.deviceTypeDetected !== 'DESKTOP') {
            <app-chats-wrapper-mobile></app-chats-wrapper-mobile>
          }
        }
      </main>
    </div>
  </div>
}

<app-cookie-banner></app-cookie-banner>
